import { Layout as MissingPrerequisiteStepLayout, metaOverrideSet as MissingPrerequisiteStepMetaOverrideSet } from './MissingPrerequisiteStep';
import { Layout as SuccessStepLayout, metaOverrideSet as SuccessStepMetaOverrideSet } from './SuccessStep';
import { Layout as CancelConfirmationStepLayout, metaOverrideSet as CancelConfirmationStepMetaOverrideSet } from './CancelConfirmationStep';
import { Layout as ChallengeSMSStepLayout, metaOverrideSet as ChallengeSMSStepMetaOverrideSet } from './ChallengeSMSStep';
import { Layout as ChallengeTOTPStepLayout, metaOverrideSet as ChallengeTOTPStepMetaOverrideSet } from './ChallengeTOTPStep';
import { Layout as ChallengePasskeyStepLayout, metaOverrideSet as ChallengePasskeyStepMetaOverrideSet } from './ChallengePasskeyStep';
import { Layout as DefaultStepLayout, metaOverrideSet as DefaultStepMetaOverrideSet } from './DefaultStep';

export default function getStep(challengeFlowCollection) {
  switch (challengeFlowCollection.resources().head().type()) {
    case 'dicrs-challenge-sms':
      return {
        Layout: ChallengeSMSStepLayout,
        metaOverrideSet: ChallengeSMSStepMetaOverrideSet,
      };
    case 'dicrs-challenge-totp':
      return {
        Layout: ChallengeTOTPStepLayout,
        metaOverrideSet: ChallengeTOTPStepMetaOverrideSet,
      };
    case 'dicrs-challenge-passkey':
      return {
        Layout: ChallengePasskeyStepLayout,
        metaOverrideSet: ChallengePasskeyStepMetaOverrideSet,
      };
    case 'dicrs-success':
      return {
        Layout: SuccessStepLayout,
        metaOverrideSet: SuccessStepMetaOverrideSet,
      };
    case 'dicrs-cancel-confirmation':
      return {
        Layout: CancelConfirmationStepLayout,
        metaOverrideSet: CancelConfirmationStepMetaOverrideSet,
      };
    case 'dicrs-missing-prereqs':
      return {
        Layout: MissingPrerequisiteStepLayout,
        metaOverrideSet: MissingPrerequisiteStepMetaOverrideSet,
      };
    default:
      return {
        Layout: DefaultStepLayout,
        metaOverrideSet: DefaultStepMetaOverrideSet,
      };
  }
}
